import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3e732d90&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=3e732d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e732d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e732d90')) {
      api.createRecord('3e732d90', component.options)
    } else {
      api.reload('3e732d90', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=3e732d90&scoped=true&", function () {
      api.rerender('3e732d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/abnormal/components/add.vue"
export default component.exports